import cookiesMO from './cookies';
import imprintMO from './imprint';
import privacyMO from './privacy';
import termsMO from './termsofuse';
import otConfig from './otConfig';
import gaConfig from './ga';
import { getGAKey } from 'helpers/googleAnalitics/GAandGTM';
import getStaticUrl from 'helpers/staticContent';

const { ga: gaId, gtm } = getGAKey(gaConfig);

export default {
  ga: gaId,
  gtm,
  title: 'Monaco',
  landingImg: `${getStaticUrl()}/my-customer-space/Landing_BM.png`,
  favicon: `${getStaticUrl()}/my-customer-space/MO_favicon.ico`,
  keyLoginConfig: 'birthDate',
  langs: ['en', 'es', 'fr', 'de', 'it', 'nl'],
  defaultLang: 'en',
  faq: [
    { from: 1, to: 19, notShowed: [8, 13] },
    { from: 20, to: 28, notShowed: [21, 22, 23, 24, 25, 28] },
    { from: 29, to: 47 },
  ],
  cookies: cookiesMO,
  imprint: imprintMO,
  privacy: privacyMO,
  terms: termsMO,
  logo: {
    src: `${getStaticUrl()}/my-customer-space/Monaco_Logo.svg`,
    alt: 'Monaco',
    height: '32px',
  },
  footerlogo: {
    src: `${getStaticUrl()}/my-customer-space/Monaco_Logo.svg`,
    alt: 'Footer Monaco',
  },
  company: 'bolttech',
  otScript: otConfig,
  footer: [
    {
      label: 'terms_of_use',
      link: '/terms-of-use',
    },
    {
      label: 'imprint',
      link: '/imprint',
    },
    {
      label: 'faq',
      link: '/faq',
    },
  ],
};
